import { Switch } from "@nt/ui/switch";
import type { ReactNode } from "react";

/**
 * A setting row: the label (and an optional line under it) on the left, the
 * switch (@nt/ui/switch) on the right. The label names the switch for screen readers.
 */
export function SwitchRow({
  id,
  label,
  description,
  checked,
  onCheckedChange,
  disabled,
}: {
  id: string;
  label: ReactNode;
  description?: ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const descriptionId = description ? `${id}-description` : undefined;
  return (
    <div data-slot="switch-row" className="flex items-start gap-4">
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <label
          id={`${id}-label`}
          htmlFor={id}
          className="text-sm font-medium text-foreground"
        >
          {label}
        </label>
        {description ? (
          <p id={descriptionId} className="text-compact text-muted-foreground">
            {description}
          </p>
        ) : null}
      </div>
      <Switch
        id={id}
        className="mt-0.5"
        aria-labelledby={`${id}-label`}
        aria-describedby={descriptionId}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(next) => onCheckedChange(next)}
      />
    </div>
  );
}
